/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useSelector, useDispatch } from 'react-redux';
import { getUserList } from 'redux/actions/userListAction';
import { createPaymentRequest, updatePaymentRequest } from 'services/billingServices';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { getClientUserList, listCasesAndLeads } from 'services/CaseServices';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';

import { totalCountEvent } from 'services/generalServices';
// TimezoneDatePicker handles all timezone conversions internally
import { UserDetailsContext } from 'context/userDetailsContext';
import { ModalHeader } from 'shared/ModalHeader';
import { AutoComplete } from 'primereact/autocomplete';
import debounce from 'lodash.debounce';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import { useCaseAndLeadsList } from 'hooks/useCaseAndLeadList';
import { useLocation } from 'react-router-dom';
import { viewCaseDetails } from 'services/case/caseServices';
import { paymentStructure } from 'modules/billing/CreateInvoice/configs/create_invoice_configs';
import { useListAccountsQuery } from 'hooks/queries/useListAccountsQuery';
import TimezoneDatePicker from 'components/common/TimezoneDatePicker/TimezoneDatePicker';
import { getTimezoneOffset, currentBrowserTimeZone } from 'utils/utility_functions/timezone';
import GeneratePaymentPlanV2, {
  numberOfPaymentsValidateRule,
  parsePaymentCountValue,
} from 'components/GeneratePaymentPlan/GeneratePaymentPlanV2';
import {
  FLAT_FEE_OPERATING_DEPOSIT_ERROR,
  FLAT_FEE_TRUST_ONLY_HELPER_TEXT,
  PAYMENT_PLAN_INSTALLMENT_AMOUNT_INVALID,
  PAYMENT_PLAN_TOTAL_MISMATCH_MESSAGE,
  PAYMENT_REQUEST_MESSAGE_MAX_LENGTH,
} from 'modules/BillingV2/PaymentRequestsV2/paymentRequestsConstantsV2';
import {
  getDepositInfoTooltipMessage,
  invoiceHasPaymentsFromDetails,
  isDepositInfoDropdownDisabled,
} from 'modules/BillingV2/InvoiceV2/components/CreateInvoiceV2/helpers/createInvoiceHelpersV2';

const CreatePaymentRequestV2 = ({
  show,
  onHide,
  onCreateSuccess,
  selectedRequest,
  caseView,
  isLeadSpecific,
  caseDetails,
  billingSummary,
  getCaseDetails,
}) => {
  const isFormFieldDisabled = selectedRequest?.payment_request_status?.toLowerCase() === 'paid';
  const [selectedCase, setSelectedCase] = useState({});
  const location = useLocation();

  const [amount, setAmount] = useState();
  const [description, setDescription] = useState();
  const [selectedTeamMember, setSelectedTeamMember] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [billingContacts, setBillingContacts] = useState([]);
  const [dontNotifyClient, setDontNotifyClient] = useState(false);
  let [formError, setFormError] = useState({
    case: '',
    team_member: '',
    amount: '',
    due_date: '',
    deposit_into: '',
  });
  let [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState();
  const [caseList, setCaseList] = useState([]);
  const [searchValue, setSearchValue] = useState();
  const [load, setLoad] = useState(false);
  const [paymentPlan, setPaymentPlan] = useState(false);
  const [numberOfPayments, setNumberOfPayments] = useState('');
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [paymentStartDate, setPaymentStartDate] = useState(null);
  const [firstPaymentAmount, setFirstPaymentAmount] = useState(null);
  const [paymentDates, setPaymentDates] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [paymentPlanError, setPaymentPlanError] = useState({});
  const userList = useSelector((state) => state.userList.userList);

  const userContext = useContext(UserDetailsContext);
  const { caseAndLeadsList } = useCaseAndLeadsList(selectedCase?.id || selectedRequest?.case_id || caseDetails?.case_id);

  const dispatch = useDispatch();
  const { addToast } = useToast();

  const { accountList: accountsList } = useListAccountsQuery({
    excludeFromLoading: true,
    enabled: show,
  });

  const hasPayments = useMemo(() => invoiceHasPaymentsFromDetails(selectedRequest), [selectedRequest]);

  const isDepositDropdownLocked = useMemo(
    () => isDepositInfoDropdownDisabled(!!selectedRequest, hasPayments),
    [selectedRequest, hasPayments]
  );

  const tooltipMessage = useMemo(() => getDepositInfoTooltipMessage(!!selectedRequest, hasPayments), [selectedRequest, hasPayments]);

  const isRetainerCase = useMemo(() => {
    const caseDetailsData = caseDetails || selectedCase || selectedRequest;
    const paymentStructureValue = caseDetailsData?.billing_preferences?.payment_structure;
    const isLead = caseDetailsData?.is_lead === true;

    if (isLead) {
      return false;
    }

    return (
      paymentStructureValue?.toLowerCase() === paymentStructure.STANDARD_RETAINER?.toLowerCase() ||
      paymentStructureValue?.toLowerCase() === paymentStructure.EVERGREEN_RETAINER?.toLowerCase()
    );
  }, [caseDetails, selectedCase, selectedRequest]);

  const isFlatFeeCase = useMemo(() => {
    const caseDetailsData = caseDetails || selectedCase || selectedRequest;
    const paymentStructureValue = caseDetailsData?.billing_preferences?.payment_structure;
    const isLead = caseDetailsData?.is_lead === true;

    if (isLead) {
      return false;
    }

    return paymentStructureValue?.toLowerCase() === paymentStructure.FLAT_FEE?.toLowerCase();
  }, [caseDetails, selectedCase, selectedRequest]);

  const scrollToPaymentPlan = () => {
    let divElement = document.getElementById('payment-plan');
    divElement?.scrollIntoView({
      top: divElement.scrollHeight, //scroll to the bottom of the element
      behavior: 'smooth', //auto, smooth, initial, inherit
    });
  };

  useEffect(() => {
    if (show) {
      totalCountEvent('user')
        .then((response) => {
          dispatch(getUserList('ACTIVE', response.data, '', 'forward', '', '', false));
        })
        .catch((error) => {});
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      const _amount = localStorage.getItem('requestPaymentAmount');
      if (_amount) {
        setAmount(Number(_amount));
        localStorage.removeItem('requestPaymentAmount');
      }
    }
  }, [show]);

  // Set due date to first payment plan date when payment plan is enabled
  useEffect(() => {
    if (paymentPlan && paymentDates && paymentDates.length > 0) {
      const firstPaymentDate = paymentDates[0]?.date;
      if (firstPaymentDate) {
        setSelectedDate(firstPaymentDate);
        formError.due_date = '';
        setFormError({ ...formError });
      }
    }
  }, [paymentPlan, paymentDates]);

  const searchCase = (e) => {
    let query = e?.query;
    setSearchValue(query);
  };

  const fetchData = useCallback(
    (query) => {
      getAllCaseList(!caseView && !isLeadSpecific ? true : false, '', true, query, 15, true);
    },
    [caseView, isLeadSpecific]
  );

  const delayedSearch = useCallback(
    debounce((query) => {
      fetchData(query);
    }, 500),
    [fetchData]
  );

  useEffect(() => {
    if (show) {
      if (searchValue !== '') {
        delayedSearch(searchValue);
      } else if (searchValue === '' && load) {
        getAllCaseList(!caseView && !isLeadSpecific ? true : false, '', true, searchValue, 15, true);
      }
    }
  }, [show, searchValue, delayedSearch, load, caseView, isLeadSpecific]);

  function getAllCaseList(
    is_lead = !caseView && !isLeadSpecific ? true : false,
    case_id = '',
    exclude_pi_case = true,
    keyword = '',
    limit = 15,
    is_filter_dropdown = true
  ) {
    listCasesAndLeads(is_lead, case_id, exclude_pi_case, keyword, limit, is_filter_dropdown)
      .then((res) => {
        let tempArray = [];
        res?.data?.case_list?.forEach((item) => {
          tempArray.push({
            label:
              item && item.case_description && item.case_description.case_name
                ? `${item.unique_number ? `${item.unique_number} ` : ''}${item.case_description.case_name}`
                : 'TBD',
            value: item.case_description.case_name,
            id: item?.case_id,
          });
        });
        if (!caseView && !isLeadSpecific) {
          res?.data?.lead_list?.forEach((item) => {
            tempArray.push({
              label:
                item && item.case_description && item.case_description.case_name
                  ? `${item.unique_number ? `${item.unique_number} ` : ''}${item.case_description.case_name}`
                  : 'TBD',
              value: item.case_description.case_name,
              id: item?.case_id,
              is_lead: item?.is_lead,
            });
          });
        }
        if (isLeadSpecific) {
          let caseDetailsData = leadSpecificCaseDetails();
          tempArray.push(caseDetailsData);
        }
        setCaseList(tempArray);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const accountsListFiltered = useMemo(() => {
    let filteredAccounts = [...(accountsList || [])];
    if (selectedCase?.id) {
      if (caseAndLeadsList?.case_list?.[0]?.default_trust_account?.[0]?.account_id) {
        filteredAccounts = filteredAccounts?.filter(
          (account) =>
            account?.account_id === caseAndLeadsList?.case_list?.[0]?.default_trust_account?.[0]?.account_id ||
            account?.account_type === 'operating'
        );
      } else if (caseAndLeadsList?.lead_list?.[0]?.default_trust_account?.[0]?.account_id) {
        filteredAccounts = filteredAccounts?.filter(
          (account) =>
            account?.account_id === caseAndLeadsList?.lead_list?.[0]?.default_trust_account?.[0]?.account_id ||
            account?.account_type === 'operating'
        );
      }
      if (caseAndLeadsList?.case_list?.[0]?.default_operating_account?.[0]?.account_id) {
        filteredAccounts = filteredAccounts.filter(
          (account) =>
            account?.account_id === caseAndLeadsList?.case_list?.[0]?.default_operating_account?.[0]?.account_id ||
            account?.account_type === 'trust'
        );
      } else if (caseAndLeadsList?.lead_list?.[0]?.default_operating_account?.[0]?.account_id) {
        filteredAccounts = filteredAccounts?.filter(
          (account) =>
            account?.account_id === caseAndLeadsList?.lead_list?.[0]?.default_operating_account?.[0]?.account_id ||
            account?.account_type === 'trust'
        );
      }
    }
    if (isFlatFeeCase) {
      filteredAccounts = filteredAccounts.filter((account) => account?.account_type === 'trust');
    }
    return filteredAccounts;
  }, [accountsList, caseAndLeadsList, selectedCase, isFlatFeeCase]);

  const leadSpecificCaseDetails = () => {
    let caseDetailsData = caseDetails ?? {};
    caseDetailsData.new_case_name = caseDetailsData.case_description?.case_name
      ? `${caseDetailsData.unique_number ? `${caseDetailsData.unique_number} ` : ''}${caseDetailsData?.case_description?.case_name}`
      : 'TBD';
    return caseDetailsData;
  };

  useEffect(() => {
    if (userList && userList.length > 0) {
      teamMembers = [];
      userList.forEach((index) => {
        let name = '';
        if (index.first_name) name += index.first_name;
        if (index.middle_name) name = name + ' ' + index.middle_name;
        if (index.last_name) name = name + ' ' + index.last_name;
        let team_member = {
          name: name,
          ...index,
        };
        teamMembers.push(team_member);
      });
      setTeamMembers([...teamMembers]);
    }
  }, [userList]);

  useEffect(() => {
    if (show && !selectedRequest) {
      const retainerDate = location?.state?.caseDetails?.billing_preferences?.retainer_date;
      const retainerAmount = location?.state?.caseDetails?.billing_preferences?.retainer_amount
        ? location?.state?.caseDetails?.billing_preferences?.retainer_amount
        : caseDetails?.billing_preferences?.retainer_amount || 0.0;
      clearFormError();
      setSelectedCase();
      setSelectedTeamMember();
      setSelectedDate(retainerDate ? retainerDate : undefined);
      setDescription();
      setAmount(retainerAmount && caseDetails && !caseDetails?.billing_preferences?.due ? Number(retainerAmount) : undefined);
      setSelectedAccount();
      setDontNotifyClient(false);
      if (caseView && !selectedRequest) {
        if (isLeadSpecific) {
          let caseDetailsData = leadSpecificCaseDetails();
          onChangeCase({
            value: { id: caseDetailsData?.case_id, label: caseDetailsData?.case_description?.case_name, ...caseDetailsData },
          });
        } else {
          let case_id = caseDetails?.case_id;
          let case_label = caseDetails?.case_description?.case_name;
          onChangeCase({ value: { id: case_id, label: case_label, ...caseDetails } });
        }
      }
    } else if (selectedRequest) {
      try {
        clearFormError();
        setSelectedCase();
        setSelectedTeamMember();
        setSelectedDate();
        setDescription();
        setAmount();
        setSelectedAccount();
        // Reset payment plan state first
        setPaymentPlan(false);
        setNumberOfPayments('');
        setSelectedFrequency(null);
        setPaymentStartDate(null);
        setFirstPaymentAmount(null);
        setPaymentDates([]);
        setFormErrors({});
        setPaymentPlanError({});

        setDescription(selectedRequest?.description);
        setAmount(selectedRequest.amount);
        setDontNotifyClient(selectedRequest?.notify_client !== undefined ? !selectedRequest?.notify_client : false);

        if (selectedRequest?.due_date) setSelectedDate(selectedRequest?.due_date);

        let billing_contact_id = selectedRequest?.billing_contact_id;

        let case_id = selectedRequest?.case_id;
        let case_label = selectedRequest?.case_description?.case_name;
        onChangeCase({ value: { id: case_id, label: case_label, ...selectedRequest } }, billing_contact_id);

        // Set payment plan state if is_payment_plan is true
        // Check for both boolean true and string "true"
        const isPaymentPlan =
          selectedRequest?.is_payment_plan === true ||
          selectedRequest?.is_payment_plan === 'true' ||
          selectedRequest?.is_payment_plan === 1;

        if (isPaymentPlan) {
          setPaymentPlan(true);

          // Populate payment plan fields from selectedRequest
          if (selectedRequest?.payment_plan) {
            if (selectedRequest.payment_plan.number_of_payments) {
              const n = parsePaymentCountValue(selectedRequest.payment_plan.number_of_payments);
              setNumberOfPayments(n != null ? String(n) : '');
            }
            if (selectedRequest.payment_plan.frequency_of_payment) {
              setSelectedFrequency(selectedRequest.payment_plan.frequency_of_payment);
            }
            if (selectedRequest.payment_plan.payment_starting_date) {
              setPaymentStartDate(selectedRequest.payment_plan.payment_starting_date);
            }
            if (selectedRequest.payment_plan.first_payment_amount) {
              setFirstPaymentAmount(selectedRequest.payment_plan.first_payment_amount);
            }
            if (selectedRequest.payment_plan.payment_plan_data && selectedRequest.payment_plan.payment_plan_data.length > 0) {
              // Pass dates directly from API - TimezoneDatePicker will handle conversion for display
              const formattedPaymentDates = selectedRequest.payment_plan.payment_plan_data.map((payment) => ({
                ...payment,
                date: payment.date, // Keep as string from API, TimezoneDatePicker handles it
              }));
              setPaymentDates(formattedPaymentDates);
            }
          }
        }

        let deposit_account_name = selectedRequest?.deposit_account_name;

        let account_list = accountsList.filter((index) => index.account_name === deposit_account_name);
        if (account_list.length > 0) setSelectedAccount(account_list[0]);
      } catch (err) {
        console.log('Err', err);
      }
    }
  }, [show, teamMembers, selectedRequest, accountsList]);

  const onSubmit = () => {
    if (validateForm()) {
      setLoading(true);
      let data = {
        case_id: selectedCase?.id,
        case_name: selectedCase?.case_description?.case_name ? selectedCase?.case_description?.case_name : selectedCase?.value,
        amount: amount,
        // TimezoneDatePicker already returns the date in correct format, no conversion needed
        due_date: selectedDate || '',
        description: description,
        billing_contact_id: selectedTeamMember?.contact_id,
        billing_contact_name: selectedTeamMember?.name,
        deposit_into: selectedAccount?.account_type,
        deposit_account_type: selectedAccount?.account_type,
        deposit_account_name: selectedAccount?.account_name,
        deposit_account_id: selectedAccount?.account_id,
        notify_client: !dontNotifyClient,
        is_payment_plan: paymentPlan,
      };
      let paymentDatesTemp = [];
      if (paymentDates?.length) {
        paymentDatesTemp = paymentDates.map((p) => {
          return {
            ...p,
            amount: p?.amount ? p.amount.toString() : '0',
            // TimezoneDatePicker already returns the date in correct format, no conversion needed
            date: p.date || '',
          };
        });
      }

      if (paymentPlan) {
        const totalAmount = paymentDatesTemp.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

        data.payment_plan = {
          // TimezoneDatePicker already returns the date in correct format, no conversion needed
          payment_starting_date: paymentStartDate || '',
          first_payment_amount: firstPaymentAmount ? firstPaymentAmount.toString() : '0',
          payment_plan_data: paymentDatesTemp,
          frequency_of_payment: selectedFrequency,
          number_of_payments: numberOfPayments,
          total_amount: totalAmount.toString(),
        };

        // set overall due date as the first scheduled date (similar to invoice)
        if (paymentDatesTemp.length > 0) {
          data.due_date = paymentDatesTemp[0].date;
        }
      }
      if (selectedRequest) {
        data = { ...selectedRequest, ...data };

        updatePaymentRequest(data, isLeadSpecific ? isLeadSpecific : selectedCase?.is_lead)
          .then((response) => {
            addToast(
              false,
              toastConstant.toasterType.SUCCESS,
              toastConstant.api.SUCCESS,
              toastConstant.message.UPDATE_PAYMENT_REQUEST_SUCCESS
            );
            setLoading(false);
            onCreateSuccess();
          })
          .catch((err) => {
            setLoading(false);
            console.log('err', err);
            addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.UPDATE_PAYMENT_REQUEST_FAILED);
          });
      } else {
        const timezone_offset = getTimezoneOffset(userContext?.userDetails?.timezone || currentBrowserTimeZone);
        createPaymentRequest({ ...data, timezone_offset }, isLeadSpecific ? isLeadSpecific : selectedCase?.is_lead)
          .then((response) => {
            addToast(
              false,
              toastConstant.toasterType.SUCCESS,
              toastConstant.api.SUCCESS,
              toastConstant.message.CREATE_PAYMENT_REQUEST_SUCCESS
            );

            setLoading(false);

            if (location?.state?.caseDetails?.billing_preferences) {
              location.state.caseDetails.billing_preferences.retainer_amount = null;
              location.state.caseDetails.billing_preferences.retainer_date = null;
            }

            onCreateSuccess();
          })
          .catch((err) => {
            setLoading(false);
            console.log('err', err);
            addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.CREATE_PAYMENT_REQUEST_FAILED);
          });
      }
    }
  };

  const validateForm = () => {
    let valid = true;
    let paid_amount = selectedRequest?.paid_amount;
    paid_amount = paid_amount ? parseInt(paid_amount) : 0;
    if (!selectedCase) {
      formError.case = 'required';
      valid = false;
    }
    if (!dontNotifyClient && !selectedTeamMember) {
      formError.team_member = 'required';
      valid = false;
    } else {
      formError.team_member = '';
    }
    if (!amount || (amount && amount <= 0)) {
      formError.amount = 'Required valid amount';
      valid = false;
    }
    if (paid_amount > 0 && amount < paid_amount) {
      formError.amount = 'Request amount should be greater than paid amount';
      valid = false;
    }
    if (!paymentPlan && !selectedDate) {
      formError.due_date = 'Required valid date';
      valid = false;
    }
    if (paymentPlan) {
      const paymentCountResult = numberOfPaymentsValidateRule.validate(numberOfPayments);
      if (paymentCountResult !== true) {
        setFormErrors((prev) => ({ ...prev, payment_number: paymentCountResult }));
        valid = false;
      } else {
        setFormErrors((prev) => ({ ...prev, payment_number: '' }));
      }
    }
    if (paymentPlan && (!paymentDates || paymentDates.length === 0)) {
      formError.due_date = 'Please enter payment plan details';
      valid = false;

      const firstPaymentValid = () => {
        if (firstPaymentAmount === null || firstPaymentAmount === undefined || firstPaymentAmount === '') return false;
        const n = typeof firstPaymentAmount === 'number' ? firstPaymentAmount : parseFloat(String(firstPaymentAmount).trim());
        return Number.isFinite(n) && n > 0;
      };

      setFormErrors((prev) => ({
        ...prev,
        payment_frequency: selectedFrequency ? '' : 'Required',
      }));

      setPaymentPlanError((prev) => {
        const next = { ...prev };
        Object.keys(next).forEach((key) => {
          if (/^\d+_(date|amount)$/.test(key)) delete next[key];
        });
        delete next.total;
        delete next.payment_plan;
        next.start_date = paymentStartDate ? '' : 'Required';
        next.first_amount = firstPaymentValid() ? '' : 'Required';
        return next;
      });

      scrollToPaymentPlan();
    } else if (paymentPlan && paymentDates && paymentDates.length > 0) {
      formError.due_date = '';
      setFormErrors((prev) => ({ ...prev, payment_frequency: '' }));
    }
    if (paymentPlan && paymentDates && paymentDates.length > 0) {
      const correctAmount = (v) => Math.round((parseFloat(v) || 0) * 100) / 100;
      const requestTotal = correctAmount(amount);

      const installmentAmountValid = (raw) => {
        if (raw === '' || raw == null) return false;
        const n = typeof raw === 'number' ? raw : parseFloat(String(raw).trim());
        return Number.isFinite(n) && n > 0;
      };

      const hasInvalidInstallment = paymentDates.some((p) => !installmentAmountValid(p?.amount));

      const planSum = paymentDates.reduce((s, p) => s + correctAmount(p?.amount), 0);
      const totalMismatch = Math.abs(planSum - requestTotal) > 0.01;

      setPaymentPlanError((prev) => {
        const next = { ...prev };
        delete next.start_date;
        delete next.first_amount;
        delete next.payment_plan;
        delete next.total;
        paymentDates.forEach((_, id) => {
          delete next[`${id}_amount`];
        });
        Object.keys(next).forEach((key) => {
          const m = key.match(/^(\d+)_amount$/);
          if (m && parseInt(m[1], 10) >= paymentDates.length) {
            delete next[key];
          }
        });
        paymentDates.forEach((p, id) => {
          if (!installmentAmountValid(p?.amount)) {
            next[`${id}_amount`] = PAYMENT_PLAN_INSTALLMENT_AMOUNT_INVALID;
          }
        });
        if (totalMismatch) {
          next.total = PAYMENT_PLAN_TOTAL_MISMATCH_MESSAGE;
        }
        return next;
      });

      if (hasInvalidInstallment || totalMismatch) {
        valid = false;
        scrollToPaymentPlan();
      }
    }
    if (!selectedAccount) {
      formError.deposit_into = 'Required';
      valid = false;
    } else if (isFlatFeeCase && selectedAccount?.account_type !== 'trust') {
      formError.deposit_into = FLAT_FEE_OPERATING_DEPOSIT_ERROR;
      valid = false;
    }
    setFormError({ ...formError });
    return valid;
  };

  const clearFormError = () => {
    formError = {
      case: '',
      team_member: '',
      rate: '',
      quantity: '',
      amount: '',
      due_date: '',
      deposit_into: '',
    };
    setFormError({ ...formError });
  };

  const onChangeCase = (e, billing_contact_id) => {
    setSelectedCase(e.value);
    setSelectedAccount();
    formError.case = '';
    setFormError({ ...formError });
    if (e.value?.id) {
      setBillingContacts([]);
      setSelectedTeamMember(undefined);
      getClientUserList(e.value.id, true, false, false, false, false, false)
        .then((response) => {
          let user_list = [];
          let selectedContact = '';
          if (response?.data && response.data.length > 0) {
            response.data.forEach((index) => {
              let name = index.first_name ? index.first_name : '';
              if (index.last_name) name = name + ' ' + index.last_name;
              let obj = {
                contact_id: index.contact_id,
                name: name,
                is_confirmed: index.is_confirmed,
              };
              if (billing_contact_id === index.contact_id) {
                selectedContact = obj;
              }
              user_list.push(obj);
            });

            // Sort the user list alphabetically by first_name
            user_list.sort((a, b) => {
              const nameA = (a?.name || '').toLowerCase();
              const nameB = (b?.name || '').toLowerCase();
              return nameA.localeCompare(nameB);
            });
          }
          setBillingContacts([...user_list]);
          if (selectedContact) setSelectedTeamMember({ ...selectedContact });
        })
        .catch((err) => {
          console.log('err', err);
        });
    } else {
      setBillingContacts([]);
      setSelectedTeamMember(undefined);
      setFormError((prev) => ({ ...prev, team_member: '' }));
    }
  };

  const populatePaymentPlan = (caseDetails) => {
    if (!caseDetails?.billing_preferences?.payment_plan_details) {
      return;
    }

    const paymentPlanDetails = caseDetails.billing_preferences;

    // Set payment plan to true if payment plan details exist
    if (paymentPlanDetails) {
      setPaymentPlan(true);
    }

    // Populate payment plan fields
    if (paymentPlanDetails?.number_of_payments) {
      const n = parsePaymentCountValue(paymentPlanDetails.number_of_payments);
      setNumberOfPayments(n != null ? String(n) : '');
    }

    if (paymentPlanDetails?.frequency_of_payment) {
      setSelectedFrequency(paymentPlanDetails.frequency_of_payment);
    }

    if (paymentPlanDetails?.payment_plan_details?.payment_starting_date) {
      setPaymentStartDate(paymentPlanDetails?.payment_plan_details?.payment_starting_date);
    }

    if (paymentPlanDetails?.payment_plan_details?.first_payment_amount) {
      setFirstPaymentAmount(paymentPlanDetails?.payment_plan_details?.first_payment_amount);
    }

    if (paymentPlanDetails?.payment_plan_details?.payment_dates && paymentPlanDetails.payment_plan_details.payment_dates.length > 0) {
      // Convert payment plan data dates to Date objects
      const formattedPaymentDates = paymentPlanDetails.payment_plan_details.payment_dates.map((payment) => ({
        ...payment,
        date: payment.date,
      }));
      setPaymentDates(formattedPaymentDates);
    }
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    }
    // Clean up the effect when the component unmounts
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]); // to remove the dropdown scroll issue in dialog dropdown

  const assignToItemTemplate = (v) => {
    if (v?.is_confirmed === false) {
      return <>{`${v?.name} (Unconfirmed)`}</>;
    }
    return <>{v?.name}</>;
  };

  return (
    <Dialog
      visible={show}
      onHide={(e) => {
        onHide(false);
      }}
      className="add-contact-dialog create-msg-popup"
      header={ModalHeader}
      closable={false}
    >
      <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
        <div className="modal-heading F-size16 text-bold">{selectedRequest ? 'Update Payment Request' : 'Create Payment Request'}</div>
      </div>
      <div className="row mt-3 d-flex align-items-center expense-popup">
        <div className="col-12 col-md-4 p-medium">
          {!caseView && !isLeadSpecific ? 'Case/Lead' : 'Case'}
          <span className="text-danger">*</span>
        </div>
        <div className="col-12 col-md-8">
          <AutoComplete
            value={selectedCase?.case_name ? selectedCase?.case_name : selectedCase}
            suggestions={caseList}
            completeMethod={searchCase}
            field="label"
            onChange={(e) => {
              setAmount(null);
              // Don't reset payment plan if we're editing a payment request
              // The payment plan state should be set from selectedRequest in the useEffect
              if (!selectedRequest) {
                setPaymentPlan(false);
                setNumberOfPayments('');
                setSelectedFrequency(null);
                setPaymentStartDate(null);
                setFirstPaymentAmount(null);
                setPaymentDates([]);
                setFormErrors({});
                setPaymentPlanError({});
              }

              onChangeCase(e);

              if (e.value?.id) {
                viewCaseDetails({ case_id: e.value.id })
                  .then((response) => {
                    const updatedCase = { ...e.value, ...response.data };
                    setSelectedCase(updatedCase);

                    if (response.data?.billing_preferences?.retainer_amount && !response?.data?.billing_preferences?.due) {
                      setAmount(response.data.billing_preferences.retainer_amount);
                    }
                    // Only populate payment plan from case details if not editing a payment request
                    // When editing, payment plan should come from selectedRequest, not case details
                    if (!selectedRequest) {
                      if (!response?.data?.billing_preferences?.due) {
                        populatePaymentPlan(response.data);
                      }
                    }
                  })
                  .catch((error) => {
                    console.log('Error loading case details:', error);
                  });
              }
            }}
            placeholder={!caseView && !isLeadSpecific ? 'Case/Lead Name' : 'Case Name'}
            filter
            disabled={caseView}
          />
          {formError && formError.case && <span className="text-danger">Required</span>}
        </div>
        <div className="col-12 col-md-4 mt-3 p-medium">
          Amount
          <span className="text-danger">*</span>
        </div>
        <div className="col-12 col-md-8 mt-3">
          <InputNumber
            className="input-shadow w-100"
            placeholder="Amount"
            value={amount}
            onValueChange={(e) => {
              setAmount(e.target.value);
              formError.amount = '';
              setFormError({ ...formError });
            }}
            mode="currency"
            currency="USD"
            locale="en-US"
            min={1}
            disabled={isFormFieldDisabled}
          />
          {formError && formError.amount && <span className="text-danger">{formError.amount}</span>}
        </div>

        <div className="col-12 col-md-4 mt-3 p-medium">
          Due Date
          <span className="text-danger">*</span>
        </div>
        <div className="col-12 col-md-8 mt-3">
          {paymentPlan && isRetainerCase ? (
            <>
              <span role="button" onClick={scrollToPaymentPlan}>
                <u>Payment Plan</u>
              </span>
              {formError && formError.due_date && <div className="text-danger">{formError.due_date}</div>}
            </>
          ) : (
            <>
              <TimezoneDatePicker
                className="input-shadow w-100"
                value={selectedDate}
                onChange={(value) => {
                  setSelectedDate(value);
                  formError.due_date = '';
                  setFormError({ ...formError });
                }}
                monthNavigator
                yearNavigator
                yearRange="1920:2070"
                timezone={userContext?.userDetails?.timezone}
                isEndOfDay={true}
                disabled={isFormFieldDisabled}
              />
              {formError && formError.due_date && <span className="text-danger d-block">{formError.due_date}</span>}
            </>
          )}
        </div>
        <div className="col-12 col-md-4 mt-3 p-medium">
          <span className="d-inline-flex align-items-center flex-shrink-0 gap-0">
            <span>
              Deposit Info
              <span className="text-danger">*</span>
            </span>
            <i
              className="pi pi-info-circle text-muted cursor-pointer deposit-info-tip-pr flex-shrink-0 align-middle"
              style={{ fontSize: '12px', lineHeight: 1, padding: '5px' }}
              aria-label="More information"
              role="img"
            />
          </span>
          <Tooltip target=".deposit-info-tip-pr" content={tooltipMessage} position="top" showDelay={300} />
        </div>
        <div className="col-12 col-md-8 mt-3 ">
          <Dropdown
            placeholder="Select"
            className="w-100"
            options={accountsListFiltered}
            onChange={(e) => {
              setSelectedAccount(e.value);
              formError.deposit_into = '';
              setFormError({ ...formError });
            }}
            optionLabel="account_name"
            filterBy="account_name"
            value={selectedAccount}
            filter
            disabled={isFormFieldDisabled || isDepositDropdownLocked}
          />
          {formError && formError.deposit_into && <span className="text-danger">{formError.deposit_into}</span>}
          {isFlatFeeCase && <small className="text-muted d-block mt-1">{FLAT_FEE_TRUST_ONLY_HELPER_TEXT}</small>}
        </div>
        <div className="col-12 col-md-4 mt-3 p-medium">Description</div>
        <div className="col-12 col-md-8 mt-3 ">
          <TextSnippetWrapper
            type="textarea"
            className="input-shadow w-100 p-2"
            value={description ?? ''}
            onChange={(e) => {
              if (e.target.value.length <= PAYMENT_REQUEST_MESSAGE_MAX_LENGTH) {
                setDescription(e.target.value);
              }
            }}
            maxLength={PAYMENT_REQUEST_MESSAGE_MAX_LENGTH}
            disabled={isFormFieldDisabled}
            autoComplete="off"
          />
          <small className="text-muted d-block text-end mt-1">
            {description?.length ?? 0}/{PAYMENT_REQUEST_MESSAGE_MAX_LENGTH}
          </small>
        </div>
        <div className="col-12 col-md-4 mt-3 p-medium">
          Contact
          {!dontNotifyClient && <span className="text-danger">*</span>}
        </div>
        <div className="col-12 col-md-8 mt-3">
          <Dropdown
            className="w-100"
            options={billingContacts}
            onChange={(e) => {
              setSelectedTeamMember(e.value);
              formError.team_member = '';
              setFormError({ ...formError });
            }}
            optionLabel="name"
            filterBy="name"
            placeholder={selectedCase ? 'Select Contact' : 'Please select case/lead first'}
            value={selectedTeamMember}
            filter
            disabled={isFormFieldDisabled || !selectedCase?.id}
            itemTemplate={assignToItemTemplate}
          />
          {formError && formError.team_member && <span className="text-danger">Required</span>}
        </div>

        {/* Payment Plan - only show for retainer cases */}
        {(isRetainerCase || paymentPlan) && (
          <div className="inner-card p-3 my-2 mt-3" id="payment-plan">
            <GeneratePaymentPlanV2
              caseDetails={caseDetails}
              amount={amount}
              paymentPlan={paymentPlan}
              setPaymentPlan={setPaymentPlan}
              numberOfPayments={numberOfPayments}
              setNumberOfPayments={setNumberOfPayments}
              setSelectedFrequency={setSelectedFrequency}
              setPaymentStartDate={setPaymentStartDate}
              setFirstPaymentAmount={setFirstPaymentAmount}
              setPaymentDates={setPaymentDates}
              setFormErrors={setFormErrors}
              setPaymentPlanError={setPaymentPlanError}
              formErrors={formErrors}
              paymentPlanError={paymentPlanError}
              paymentDates={paymentDates}
              selectedFrequency={selectedFrequency}
              paymentStartDate={paymentStartDate}
              firstPaymentAmount={firstPaymentAmount}
              selectedRequest={selectedRequest}
            />
          </div>
        )}
      </div>
      <div className="footer-btn d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <Checkbox
            inputId="notify_client"
            checked={dontNotifyClient}
            onChange={(e) => {
              setDontNotifyClient(e.checked);
              if (e.checked) {
                setFormError((prev) => ({ ...prev, team_member: '' }));
              }
            }}
            disabled={isFormFieldDisabled || selectedRequest}
          />
          <label htmlFor="notify_client" className="ms-2">
            Do not send this payment request to the billing contact
          </label>
        </div>
        <div className="text-nowrap">
          <Button className="p-button-secondary outline mx-2" label="Cancel" onClick={() => onHide(false)} />
          <Button
            className="p-button p-button-secondary"
            label={selectedRequest ? 'Update' : 'Save'}
            onClick={onSubmit}
            loading={loading}
            disabled={isFormFieldDisabled}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default CreatePaymentRequestV2;
